import React from 'react';
import type { BillingCadence } from '../../config/commercialPlans';
import { cn } from '../../lib/utils';

export function PricingBandBillingSummary({
  bandKicker,
  bandLabel,
  bandBody,
  billingKicker,
  billingLabel,
  billingNote,
  billingCadence,
  annualBadge,
  className,
}: {
  bandKicker: string;
  bandLabel: string;
  bandBody: string;
  billingKicker: string;
  billingLabel: string;
  billingNote: string;
  billingCadence: BillingCadence;
  annualBadge?: string;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-0 overflow-hidden rounded-[1.5rem] border border-brand-primary/10 bg-brand-bg md:grid-cols-2',
        className
      )}
    >
      <div className="border-b border-brand-primary/10 p-8 md:border-b-0 md:border-r">
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-[var(--ir-muted)]">
          {bandKicker}
        </p>
        <p className="mt-4 font-serif text-3xl font-bold text-brand-primary">
          {bandLabel}
        </p>
        <p className="mt-4 text-base leading-relaxed text-[var(--ir-muted)]">
          {bandBody}
        </p>
      </div>
      <div className="p-8">
        <div className="flex items-center gap-3">
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[var(--ir-muted)]">
            {billingKicker}
          </p>
          {billingCadence === 'annual' && annualBadge ? (
            <span className="rounded-full bg-brand-accent px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] text-white">
              {annualBadge}
            </span>
          ) : null}
        </div>
        <p className="mt-4 font-serif text-3xl font-bold text-brand-primary">
          {billingLabel}
        </p>
        <p className="mt-4 text-base leading-relaxed text-[var(--ir-muted)]">
          {billingNote}
        </p>
      </div>
    </div>
  );
}
